import {
  DailyCareLogContextState,
  DailyCareLogContextAction,
  DailyCareLogContextActionType,
} from './types';

const reducer = (prevState: DailyCareLogContextState, action: DailyCareLogContextAction) => {
  switch (action.type) {
    case DailyCareLogContextActionType.SET_NAVIGATION_HEADER:
      return {
        ...prevState,
        navigationHeader: {
          ...prevState.navigationHeader,
          active: action.active,
          text: action.text,
        },
      };

    case DailyCareLogContextActionType.TOGGLE_BOTTOM_NAVIGATION:
      return {
        ...prevState,
        bottomNavigation: {
          visible: action.visible,
          active: action.active,
        },
      };
  }
};
export default reducer;
